<template>
  <svg :height="height" :width="width" viewBox="0 0 397.8 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3553_2525)">
      <path
        d="M150.7 25.9001C149.5 25.8001 148.4 26.5001 148 27.6001L129.1 71.7001L110.2 27.6001C109.8 26.5001 108.7 25.8001 107.5 25.9001H97.1L121.8 85.4001C122.2 86.5001 123.3 87.2001 124.5 87.2001H133.9C135.1 87.2001 136.2 86.5001 136.6 85.4001L161.3 25.9001H150.7Z"
        :fill="color"
      />
      <path
        d="M293.8 87.1999H281C280.1 87.1999 279.2 86.6999 278.7 85.9999L262.5 63.4999L246.4 85.9999C245.9 86.7999 245 87.1999 244 87.2999H231.2L255.3 53.4999L238.3 29.7999L235.5 25.8999H247.3C248.9 25.8999 250.4 26.6999 251.4 27.9999L262.4 43.3999L273.4 27.9999C274.3 26.6999 275.8 25.8999 277.5 25.8999H289.3L286.5 29.7999L269.5 53.4999L293.8 87.1999Z"
        :fill="color"
      />
      <path d="M319.3 28.9999V87.1999H311C309.8 87.1999 307.9 86.7999 307.9 83.8999V25.8999H316.2C317.4 25.8999 319.3 26.0999 319.3 28.9999Z" :fill="color" />
      <path d="M7.8 15.6C12.1078 15.6 15.6 12.1078 15.6 7.8C15.6 3.49218 12.1078 0 7.8 0C3.49218 0 0 3.49218 0 7.8C0 12.1078 3.49218 15.6 7.8 15.6Z" :fill="color" />
      <path d="M313.6 15.6C317.908 15.6 321.4 12.1078 321.4 7.8C321.4 3.49218 317.908 0 313.6 0C309.292 0 305.8 3.49218 305.8 7.8C305.8 12.1078 309.292 15.6 313.6 15.6Z" :fill="color" />
      <path d="M13.5 28.9999V87.1999H5.2C4 87.1999 2.1 86.7999 2.1 83.8999V25.8999H10.4C11.5 25.8999 13.5 26.0999 13.5 28.9999Z" :fill="color" />
      <path
        d="M92.1 57.1999C92.1 57.4999 92.1 84.1999 92.1 84.1999C92.2 85.7999 91 87.0999 89.5 87.1999C89.3 87.1999 89.2 87.1999 89 87.1999H80V55.9999C80 44.4999 71.4 35.9999 59.8 36.0999C48.2 36.1999 39.6 44.5999 39.6 56.0999V87.1999H30.7C29.5 87.1999 27.6 86.7999 27.6 83.8999V57.9999C27.6 46.4999 31.8 37.1999 39 31.3999C44.4 26.9999 51.4 24.5999 59.7 24.4999C68 24.3999 75.2 26.9999 80.7 31.3999C87.8 37.1999 92.1 46.1999 92.1 57.1999Z"
        :fill="color"
      />
      <path
        d="M197.3 24.5C179.6 24.5 165.2 38.9 165.2 56.6C165.2 74.3 179.6 88.7 197.3 88.7C215 88.7 229.4 74.3 229.4 56.6C229.3 38.9 215 24.5 197.3 24.5ZM197.3 77.6C185.7 77.6 176.3 68.2 176.3 56.6C176.3 45 185.7 35.6 197.3 35.6C208.9 35.6 218.3 45 218.3 56.6C218.3 68.2 208.9 77.6 197.3 77.6Z"
        :fill="color"
      />
      <path
        d="M394.7 25.9H386.4V32.3C373 20.7 352.8 22.2 341.2 35.5C329.6 48.8 331.1 69.1 344.4 80.7C356.4 91.1 374.3 91.1 386.4 80.7V84C386.4 86.9 388.4 87.3 389.5 87.3H397.8V29C397.8 26.1 395.9 25.9 394.7 25.9ZM365.4 77.6C353.8 77.6 344.4 68.2 344.4 56.6C344.4 45 353.8 35.6 365.4 35.6C377 35.6 386.4 45 386.4 56.6C386.4 68.2 377 77.6 365.4 77.6Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_3553_2525">
        <rect width="397.8" height="88.7" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
interface Props {
  width?: string | number
  height?: string | number
  color?: string
}

withDefaults(defineProps<Props>(), {
  width: '120',
  height: '30',
  color: 'white',
})
</script>
